// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__VS9tn","mainBlock":"styles_mainBlock__260uV","br":"styles_br__1spEj","PaymentSocialBlock":"styles_PaymentSocialBlock__1FMFs"};